import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        principal: '#b0b69a',
        primary: '#b0b69a',
        secondary: '#fad7da',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        grey: '#BDBDBD'
      },
      dark: {
        principal: '#6b705c',  // Versión más oscura de tu color principal
        primary: '#6b705c',     // Mantiene coherencia con el principal
        secondary: '#d8a1a5',   // Versión más oscura del rosado
        accent: '#5d99ff',      // Azul un poco más oscuro
        error: '#ff3d3d',       // Rojo más intenso para contraste
        info: '#1e88e5',        // Azul info más oscuro
        success: '#43a047',     // Verde success más oscuro
        warning: '#ffb300',     // Amarillo más oscuro
        grey: '#616161',        // Gris más oscuro para fondos
        background: '#27272a',  // Color de fondo típico dark
        surface: '#1e1e1e',     // Para componentes superficiales
        text: '#e0e0e0',         // Texto claro para contraste
      }
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: 'md',
  },
});
